import React from "react";
import { Card } from "@/components/ui/card";
export const PieChartTable = ({
  selectedCategory,
  visibleCategories,
  visibleSubcategories,
  allowOverflow = false
}: {
  selectedCategory: string | null;
  visibleCategories: {
    desc: string;
    suma: number;
  }[];
  visibleSubcategories: {
    desc: string;
    suma: number;
  }[];
  allowOverflow?: boolean;
}) => {
  return <Card className={`w-fit flex-1 rounded-3xl shadow-none ${allowOverflow ? "overflow-visible border-0 !bg-transparent" : "overflow-hidden bg-primary/5 p-4"}`} data-sentry-element="Card" data-sentry-component="PieChartTable" data-sentry-source-file="PieChartTable.tsx">
      <div className={`flex flex-col gap-2 pr-4 ${allowOverflow ? "overflow-visible" : "scrollbar max-h-[600px] overflow-y-auto"}`}>
        {selectedCategory ? visibleSubcategories.map((subcategory, idx) => <>
                <div key={subcategory.desc} className="flex justify-between">
                  <span className="w-[60%]">{subcategory.desc}</span>
                  {/* eslint-disable-next-line @shopify/jsx-no-hardcoded-content */}
                  <span className="text-end">
                    {Intl.NumberFormat("ro-RO").format(subcategory.suma)} RON
                  </span>
                </div>
                <div className={`my-0.5 h-[1px] bg-primary/5 ${idx === visibleSubcategories.length - 1 ? "hidden" : ""}`} />
              </>) : visibleCategories.map((category, idx) => <>
                <div key={category.desc} className="flex justify-between">
                  <span className="w-[60%]">{category.desc}</span>
                  {/* eslint-disable-next-line @shopify/jsx-no-hardcoded-content */}
                  <span className="text-end">
                    {Intl.NumberFormat("ro-RO").format(category.suma)} RON
                  </span>
                </div>
                <div className={`my-0.5 h-[1px] bg-primary/5 ${idx === visibleCategories.length - 1 ? "hidden" : ""}`} />
              </>)}
      </div>
    </Card>;
};